'use strict';

/* Services */
import ConfigService from './config/config.service';
import DynamicPageService from './dynamic-page/dynamic-page.service';
import HistoryService from './history/history.service';
import RequestedUserService from './requested-user/requested-user.service';
import SettingsService from './settings/settings.service';
import StorageService from './storage/storage.service';

/* Module */
export default angular.module('conduu.ap.services', [ConfigService, DynamicPageService, HistoryService, RequestedUserService,
  SettingsService, StorageService])
.name;



// WEBPACK FOOTER //
// ./client/~ap/services/index.js